export function createClasses(className: string): string {
  return `minimal__${className}`;
}
